export const expectedIncomeTableColumns = [
  {
    key: "year",
    label: "Jahr",
    minWidth: 60,
    maxWidth: 60,
    justifyContent: "start",
  },
  {
    key: "bruttoRentalIncome",
    label: "Miete (+)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "feesAndPenalties",
    label: "Werbungskosten (-)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 160,
    maxWidth: 160,
  },
  {
    key: "totalDepreciation",
    label: "AfA (-)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "totalPropertyExpenses",
    label: "Nebenkosten (-)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 140,
    maxWidth: 140,
  },
  {
    key: "totalLoanInterest",
    label: "Zinsen (-)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "investObjectIncome",
    label: "Einkünfte VuV (=)",
    justifyContent: "end",
    cellType: "currency",
    minWidth: 180,
    maxWidth: 180,
  },
];

export const expectedIncomeTableBottomText =
  "* VuV = Voraussichtliche Einkünfte aus Vermietung und Verpachtung";

export const getEstimatedTaxResultsTableColumns = () => [
  {
    key: "year",
    label: "Jahr",
    minWidth: 50,
    maxWidth: 50,
  },
  {
    key: "taxableIncome",
    label: "zvE vor Kauf",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "familyTax",
    label: "ESt vor Kauf",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "investObjectIncome",
    label: "VuV",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "taxableIncomeAfterPurchase",
    label: "zvE nach Kauf",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "familyTaxAfterPurchase",
    label: "ESt nach Kauf",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "taxSavings",
    label: "Ergebnis",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
];

export const estimatedTaxResultsTableBottomText = `
* zvE = Voraussichtlicher zu versteuerndes Einkommen <br />
* ESt vor Kauf = Voraussichtliche Einkommensteuer vor Kauf <br />
* VuV = Voraussichtliche Einkünfte aus Vermietung und Verpachtung <br />
* zvE nach Kauf = Voraussichtliches zu versteuerndes Einkommen nach Kauf <br />
* ESt nach Kauf = Voraussichtliche Einkommensteuer nach Kauf <br />
`;

export const loanSpecialTableColumns = [
  {
    key: "year",
    label: "Jahr",
    minWidth: 50,
    maxWidth: 50,
  },
  {
    key: "specialLoanInterestRate",
    label: "Zins in %",
    cellType: "percentage",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "specialLoanInterest",
    label: "Zins p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "specialLoanPrincipalPercentage",
    label: "Tilgung in %",
    cellType: "percentage",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "specialLoanPrincipalPayment",
    label: "Tilgung p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "totalSpecialLoanPayment",
    label: "Rate p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "remainingSpecialLoanPrincipal",
    label: "Restschuld",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
];

export const loanRegularTableColumns = [
  {
    key: "year",
    label: "Jahr",
    minWidth: 50,
    maxWidth: 50,
  },
  {
    key: "regularLoanInterestRate",
    label: "Zins in %",
    cellType: "percentage",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "regularLoanInterest",
    label: "Zins p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "regularLoanPrincipalPercentage",
    label: "Tilgung in %",
    cellType: "percentage",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "regularLoanPrincipalPayment",
    label: "Tilgung p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "totalRegularLoanPayment",
    label: "Rate p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "remainingRegularLoanPrincipal",
    label: "Restschuld",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
];

export const totalOverviewTableColumns = [
  {
    key: "year",
    label: "Jahr",
    minWidth: 50,
    maxWidth: 50,
  },
  {
    key: "bruttoRentalIncome",
    label: "Miete (+)",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "taxSavings",
    label: "Steuerersparnis (+)",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "totalPropertyExpenses",
    label: "Nebenkosten (-)",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "totalLoanInterest",
    label: "Zinsen (-)",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  // {
  //   key: "investorCashFlowBeforeLoan",
  //   label: "Liquidität (vor Tilgung) (-)",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  // {
  //   key: "totalLoanPrincipalPayment",
  //   label: "Tilgung / Tilgungsersatz (-)",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  // {
  //   key: "investorCashFlowAfterLoan",
  //   label: "Liquidität(nach Tilgung)",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  {
    key: "ownCapital",
    label: "Eigenkapital (-)",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  // {
  //   key: "totalLoanPrincipal",
  //   label: "Restschuld",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  // {
  //   key: "totalPropertyValue",
  //   label: "Preis",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  {
    key: "investorCashFlow",
    label: "Liquidität p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "investorCashFlowMonthly",
    label: "Liquidität mlt",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  // {
  //   key: "investorCashFlowAverage",
  //   label: "Durchschnittliche Liquidität mtl.",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
];

export const getSummaryTableColumns = ({
  isKfw297Limit100Enabled,
  isKfw297Limit150Enabled,
}: {
  isKfw297Limit100Enabled: boolean;
  isKfw297Limit150Enabled: boolean;
}) => [
  {
    key: "year",
    label: "Jahr",
    minWidth: 50,
    maxWidth: 50,
  },
  {
    key: "investorCashFlow",
    label: "Liquidität p.a.",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  {
    key: "propertyValue",
    label: "Wohnungswert",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 120,
  },
  // {
  //   key: "investmentAcc",
  //   label: "Investment (kumulativ)",
  //   cellType: "currency",
  //   minWidth: 120,
  //   maxWidth: 120,
  // },
  ...(isKfw297Limit100Enabled || isKfw297Limit150Enabled
    ? [
        {
          key: "remainingSpecialLoanPrincipal",
          label: "Restschuld (Finanzierung 1)",
          cellType: "currency",
          minWidth: 140,
          maxWidth: 140,
        },
      ]
    : []),
  {
    key: "remainingRegularLoanPrincipal",
    label:
      isKfw297Limit100Enabled || isKfw297Limit150Enabled
        ? "Restschuld (Finanzierung 2)"
        : "Restschuld",
    cellType: "currency",
    minWidth: 140,
    maxWidth: 140,
  },
  {
    key: "earlySaleProfit",
    label: "Nettogewinn bei Verkauf abzüglich aller Investitionen",
    cellType: "currency",
    minWidth: 120,
    maxWidth: 180,
  },
];
